// Lib
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';

import getClientConfig from '../../utils/getClientConfig';
import ErrorBoundary from '../../components/error/errorBoundary/ErrorBoundary';
import { getPlatformDetailsSelector } from '../../platform/platformSelector';
import { isPlatformIos } from '../../platform/utils/platformDetailsUtils';
import { ApplicationType } from '../../../common/platform/platformTypes';

const clientConfig = getClientConfig();

const EmptyErrorRenderer = () => null;

/**
 * This meta tag is to display a smart app banner on iOS devices when the user visits the Milanote web app.
 *
 * Read more here: https://developer.apple.com/documentation/webkit/promoting_apps_with_smart_app_banners
 */
const AppStoreMetaLink = ({ currentBoardId }) => {
    const platformDetails = useSelector(getPlatformDetailsSelector);

    // Only show this meta tag on Milanote accessed via the browser on iOS devices
    if (!isPlatformIos(platformDetails) || platformDetails.appType !== ApplicationType.web) return null;

    const appArgument = currentBoardId ? `milanote://board/${currentBoardId}` : 'milanote://';
    const appLink = `app-id=${clientConfig.appStore.iOSAppId}, app-argument=${appArgument}`;

    return (
        <ErrorBoundary ErrorRenderer={EmptyErrorRenderer}>
            <Helmet>
                <meta name="apple-itunes-app" content={appLink} />
            </Helmet>
        </ErrorBoundary>
    );
};

AppStoreMetaLink.propTypes = {
    currentBoardId: PropTypes.string,
};

export default AppStoreMetaLink;
